// extracted by mini-css-extract-plugin
export var buttonContainer = "ValuesSlider-module--buttonContainer--d562b";
export var leftControlButton = "ValuesSlider-module--leftControlButton--c27b6";
export var rightControlButton = "ValuesSlider-module--rightControlButton--7217c";
export var sliderContainer = "ValuesSlider-module--sliderContainer--e7b01";
export var sliderText = "ValuesSlider-module--sliderText--a2af8";
export var sliderWrapper = "ValuesSlider-module--sliderWrapper--c9f73";